import { Link } from "react-router-dom";

class UsersList extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {  }
	}

displayTeacherName(user) {
	return (user.primary_student_list && user.primary_student_list.name) ? ', ' + user.primary_student_list.name : ''
}
	
displayLastActive(user) {
	return user.last_active ? ', ' + new Date(user.last_active).toDateString() : ''
}

displaySchool(user) {
	return user.school && user.school.name ? ', ' + user.school.name : ''
}

	displayUserDetails(user) {
		var route = "/users/" + user.id + "/details";
		return (
			<Link to={ route } target="_blank">
				{ user.first_name } { user.last_name } (ID: { user.id }) - { " " }
				{user.role}, {user.product} {this.displayTeacherName(user)}
				{this.displayLastActive(user)} {this.displaySchool(user)}
			</Link>
		);
	}

	render() {
		var usersList = _.map(this.props.users, (user) => {
			console.log(user)
			return (
				<li key={ user.id }>
					{ this.displayUserDetails(user) }
				</li>
			);
		});

		return (
			<ul>
				{ usersList }
			</ul>
		);
	}
}

UsersList.propTypes = PageStrictPropTypes({
	users: PropTypes.array.isRequired,
});

module.exports = UsersList;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/UsersList.js